// extracted by mini-css-extract-plugin
module.exports = {"container":"apartments-module--container--MaMTf","apartments":"apartments-module--apartments--3Qhfn"};